<pos-progress-bar class="position-absolute"></pos-progress-bar>
<router-outlet></router-outlet>
<pos-spinner></pos-spinner>
<pos-app-version-check></pos-app-version-check>
<pos-screen-state></pos-screen-state>
